/* Anmelde-Popup: erscheint, wenn eine Aktion ein Konto braucht (Upload, Löschen, Server-Karten) oder über Settings → Backend. */
import { useRef, useState } from 'react';
import type { FormEvent } from 'react';
import type { BackendSession } from '../net/session.ts';
import { Dialog, DialogBody, DialogFoot } from './dialog.tsx';
import { useStore, useT } from './hooks.ts';

export function LoginDialog(props: { session: BackendSession; onDone: (ok: boolean) => void }) {
  const t = useT();
  const snap = useStore(props.session);
  const [email, setEmail] = useState(snap.email);
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const pw = useRef<HTMLInputElement>(null);

  const go = async (ev?: FormEvent) => {
    ev?.preventDefault();
    setBusy(true); setMsg(t('be.signing_in'));
    try {
      await props.session.login(email, password);
      props.onDone(true);
    } catch (err) {
      setMsg(t('be.login_failed', { msg: (err as Error).message }));
      setBusy(false);
      pw.current?.select();
    }
  };

  return (
    <Dialog title={t('be.login_title')} onClose={() => props.onDone(false)}>
      <form onSubmit={go}>
        <DialogBody>
          <div className="row">
            <label htmlFor="xf-login-email">{t('be.email')}</label>
            <input id="xf-login-email" type="text" className="inp" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus={!email} />
          </div>
          <div className="row">
            <label htmlFor="xf-login-pw">{t('be.password')}</label>
            <input id="xf-login-pw" ref={pw} type="password" className="inp" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus={!!email} />
          </div>
          <p className="small" role="status">{msg ?? t('be.login_intro', { url: snap.base || window.location.origin })}</p>
        </DialogBody>
        <DialogFoot>
          <button type="button" className="btn" onClick={() => props.onDone(false)}>{t('be.cancel')}</button>
          <button type="submit" className="btn primary" disabled={busy}>{t('be.login')}</button>
        </DialogFoot>
      </form>
    </Dialog>
  );
}
